import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Gravatar from "react-gravatar";
import { options } from "util/reactTableFuncs";
import { TeamUser } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const TeamUsersTable = ({
  teamUsers,
  showSearch,
  rowEvents,
  showTeam,
  showAccount,
  showEmail,
  showRole,
  showPic,
  cardTable,
}: {
  teamUsers: TeamUser[];
  showSearch: boolean;
  rowEvents?: any;
  showTeam?: boolean;
  showAccount?: boolean;
  showEmail?: boolean;
  showRole?: boolean;
  showPic?: boolean;
  cardTable?: boolean;
}) => {
  const gravatarFormatter = (cell: any, row: TeamUser) => {
    if (row.email) {
      return (
        <span style={{ fontWeight: 600 }}>
          {showPic ? (
            <Gravatar
              className="gravatar-pic"
              size={40}
              default="retro"
              email={row.email}
            />
          ) : null}
          {cell}
        </span>
      );
    }
    return <span>{cell}</span>;
  };
  const { SearchBar } = Search;
  const columns: Array<Object> = [
    {
      dataField: "username",
      text: "Username",
      formatter: gravatarFormatter,
      headerAlign: "left",
      align: "left",
    },
  ];
  if (showTeam) {
    columns.push({
      dataField: "team_name",
      text: "Team",
      headerAlign: "left",
      align: "left",
    });
  }
  if (showAccount) {
    columns.push({
      dataField: "account_name",
      text: "Account",
      headerAlign: "left",
      align: "left",
    });
  }
  if (showRole) {
    columns.push({
      dataField: "role_name",
      text: "Role",
      headerAlign: "left",
      align: "left",
    });
  }
  if (showEmail) {
    columns.push({
      dataField: "email",
      text: "Email",
      headerAlign: "left",
      align: "left",
    });
  }
  let dataSorted =
    teamUsers &&
    teamUsers.sort((a: TeamUser, b: TeamUser) =>
      a.username.localeCompare(b.username)
    );
  return (
    <div>
      {teamUsers ? (
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <>
              {showSearch ? (
                <div className={styles["table__search-container"]}>
                  <SearchBar
                    className={styles["table__search-container__search-bar"]}
                    {...props.searchProps}
                  />
                </div>
              ) : null}
              <div className={Table.classNames.table}>
                {cardTable ? (
                  <BootstrapTable
                    {...props.baseProps}
                    classes="card-table text-center"
                    bordered={false}
                    bootstrap4
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    bootstrap4
                    hover
                    condensed
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                )}
              </div>
            </>
          )}
        </ToolkitProvider>
      ) : (
        <p>No Teams Users Available</p>
      )}
    </div>
  );
};

export default TeamUsersTable;
